// extracted by mini-css-extract-plugin
export default {"root":"SimpleFooter_root__5NGe4","socialIcons":"SimpleFooter_socialIcons__zHQ-Z"};